module.exports = __webpack_public_path__ + "img/arbre_3.16b4d0f6.png";